module.exports = __webpack_public_path__ + "f17f9b312e559bd63608852316431fbf.svg";